var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white p-2"},[_c('TabIndicator',{attrs:{"index":_vm.getBookingTabId}}),_c('KeepAlive',[_c(_vm.IsComponent,{tag:"component",on:{"changeBookingTab":_vm.changeBookingTab}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }